<template>
  <div>
    <v-container fluid v-if="loadingApps || loadingAppsError">
      <gg-card>
        <gg-card-text>
          <v-row v-if="loadingApps">
            <v-col cols="12" class="text-center">
              <v-progress-circular indeterminate
                                   width="2"
                                   size="64"
                                   color="primary"
                                   class="my-4"
              />
            </v-col>
          </v-row>
          <v-row v-else-if="loadingAppsError">
            <v-col cols="12" class="text-center">
              <v-icon size="180" color="red">mdi-close-circle</v-icon>
              <p>{{ loadingAppsError }}</p>
            </v-col>
            <v-col cols="12" class="text-center">
              <gg-btn @click="setStep(1)" tile>
                Back
              </gg-btn>
            </v-col>
          </v-row>
        </gg-card-text>
      </gg-card>
    </v-container>
    <div v-else class="pt-6">
      <component :is="activeComponent"
                 :loading-apps="loadingApps"
                 :apps-error="loadingAppsError"
                 :loading="loading"
                 @submit="submit"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'WizardStepTwo',
  components: {
    'Migration': () => import('@/components/Wizard/StepTwo/Migration'),
    'Wordpress': () => import('@/components/Wizard/StepTwo/WordPress'),
    'StarterSite': () => import('Components/Wizard/StepTwo/StarterSite'),
    'Unknown': () => import('@/components/Wizard/UnknownFlow')
  },
  data: () => ({
    loading: false,
    loadingApps: false,
    loadingAppsError: '',
    flows: {
      wordpress: 'Wordpress',
    }
  }),
  computed: {
    ...mapGetters({
      path: 'wizard_model/path',
      service_id: 'wizard/service_id',
      application: 'wizard_model/application'
    }),
    activeComponent () {
      if (this.path === 'New Website') {
        if (this.flows[this.application?.flow] !== undefined) {
          return this.flows[this.application.flow]
        }
        return 'Unknown'
      }
      switch (this.path) {
        case 'Starter Site':
          return 'StarterSite'
        case 'Migration':
          return 'Migration'
        default:
          return 'Migration'
      }
    }
  },
  methods: {
    ...mapMutations({
      setStep: 'wizard/SET_STEP',
      clearStep2: 'wizard/CLEAR_STEP2'
    }),
    ...mapActions({
      loadStepTwoData: 'wizard/loadStepTwoData',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    submit () {
      this.setStep(3)
    },
    goBack () {
      this.setStep(1)
      this.clearStep2()
    }
  },
  async mounted () {
    const flowsNeedsData = ['Starter Site'] // non-application paths where wizard_step2 should be called
    const appsNeedsData = ['wordpress', 'wpwoocommerce', 'extendify']
    const pathToLoadData = flowsNeedsData.indexOf(this.path) !== -1
    const appToLoadData = appsNeedsData.indexOf(this.application?.key) !== -1
    if (!appToLoadData && !pathToLoadData) return
    const application = appToLoadData ? this.application.key : undefined
    const flow = pathToLoadData ? this.path : undefined
    this.loadingApps = true
    try {
      await this.loadStepTwoData({ serviceID: this.service_id, application, flow })
    } catch (e) {
      this.reportError(e)
      this.loadingAppsError = 'An error occurred during wizard configuration. Please go back and try again.'
    } finally {
      this.loadingApps = false
    }
  },
}
</script>
